import {Notyf} from 'notyf';

const notyf = new Notyf({
  duration: 1000,
  position: {
    x: 'right',
    y: 'top',
  },
  types: [
    {
      type: 'error',
      background: '#D61313',
      duration: 2000,
      dismissible: true,
      className: 'notify__wrapper',
      ripple: false,
      icon: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M12 12L12.0553 11.9723C12.8195 11.5903 13.6799 12.2805 13.4727 13.1093L12.5273 16.8907C12.3201 17.7195 13.1805 18.4097 13.9447 18.0277L14 18M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13ZM13 8H13.01V8.01H13V8Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          '</svg>',
    }
  ]
});

window.onload = function () {
  const pagination = document.querySelector('.js--pagination');

  if (pagination) {
    const changedWrapper = pagination.getAttribute('data-wrapper');
    const dataFilters = pagination.getAttribute('data-filter-form');
    const callbackName = pagination.getAttribute('data-callback-data');
    const url = pagination.getAttribute('data-url');
    let activePage = parseInt(pagination.getAttribute('data-page'));
    let totalWrapper = pagination.getAttribute('data-total-wrapper');
    if (!totalWrapper) {
        totalWrapper = '.js--pagination-total-wrapper'
    }

    let activePrevPagesArray = [];

    const paginationList = document.querySelector('.js--pagination_list_pages');
    const showMoreBtn = document.querySelector('.js--pagination_load_more');
    const pagePrevBtn = document.querySelector('.js--pagination_prev');
    const pageNextBtn = document.querySelector('.js--pagination_next');
    const pageFirstBtn = document.querySelector('.js--pagination_first');
    const pageLastBtn = document.querySelector('.js--pagination_last');
    const pageMobile = document.querySelector('.js--pagination_list_pages_mobile_page');
    const pagesMobile = document.querySelector('.js--pagination_list_pages_mobile_pages');

    const totalWrapperElements = document.querySelectorAll(totalWrapper);

    function addEventPageItems() {
      document.querySelectorAll('.js--page_item').forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault();
          loadPage(getItemPage(item), false, dataFilters);
        });
      });
    }

    function replacePaginationItems(newItems) {
      paginationList.innerHTML = '';
      paginationList.innerHTML = newItems;
      if (newItems === '') {
        pagePrevBtn.style.display = 'none';
        pageNextBtn.style.display = 'none';
        pageFirstBtn.style.display = 'none';
        pageLastBtn.style.display = 'none';
      } else {
        pagePrevBtn.style.display = 'inline-block';
        pageNextBtn.style.display = 'inline-block';
        pageFirstBtn.style.display = 'inline-block';
        pageLastBtn.style.display = 'inline-block';
      }
    }

    function checkNextPage(page) {
      if (!page) {
        showMoreBtn.style.display = 'none';
      } else {
        showMoreBtn.style.display = 'flex';
      }
    }

    checkNextPage(activePage !== getTotalPages())

    function updatePaginationState() {
      pagePrevBtn.classList.toggle('disabled', activePage === 1);
      pageNextBtn.classList.toggle('disabled', activePage === getTotalPages());
      pageFirstBtn.classList.toggle('disabled', activePage === 1);
      pageLastBtn.classList.toggle('disabled', activePage === getTotalPages());
    }

    function state() {
      const queryString = window.location.search.slice(1);
      const params = {};

      if (queryString) {
        const pairs = queryString.split('&');
        pairs.forEach(pair => {
          const [key, value] = pair.split('=');
          if (key) {
            const decodedKey = decodeURIComponent(key);
            const decodedValue = decodeURIComponent(value || '');

            params[decodedKey] = decodedValue;
          }
        });
      }

      return params;
    }

    function updateQueryString() {
      const stateData = state();
      console.log(stateData);
      // const currentPages = stateData.get('page');
      // stateData.set('page', currentPages);
      // window.history.replaceState({}, '', `${window.location.pathname}?${stateData}`);
    }

    function queryStringToFormData(queryString, filters) {
      const formData = new FormData();
      const existingKeys = new Set();

      if (filters) {
        const formDataFilters = new FormData(document.querySelector(filters));
        for (let pair of formDataFilters.entries()) {
          existingKeys.add(pair[0]);
          formData.append(pair[0], pair[1]);
        }
      }

      for (const key in queryString) {
        const baseKey = key.replace(/\[\]$/, '');

        if ([...existingKeys].some(existingKey => existingKey === baseKey || existingKey === `${baseKey}[]`)) {
          continue;
        }

        formData.append(key, queryString[key]);
      }

      return formData;
    }
    function getItemPage(item) {
      return parseInt(item.getAttribute('href').replace('#!', ''))
    }

    function getTotalPages() {
        return  parseInt(pagination.getAttribute('data-pages'));
    }

    function renderArchive(itemsText, targetElement, templateHeader, templateList) {
      Object.keys(itemsText).forEach(date => {
        const existingHeader = targetElement.querySelector(`[data-date="${date}"]`);

        if (!existingHeader) {
          const headerClone = templateHeader.content.cloneNode(true);
          const header = headerClone.children[0];
          header.setAttribute('data-date', date);
          header.textContent = date;
          targetElement.appendChild(header);
        }

        const existingList = targetElement.querySelector(`[data-fordate="${date}"]`);

        if (!existingList) {
          const listClone = templateList.content.cloneNode(true);
          const list = listClone.children[0];

          list.setAttribute('data-fordate', date);

          itemsText[date].forEach(article => {
            list.innerHTML += article;
          });

          targetElement.appendChild(list);
        } else {
          itemsText[date].forEach(article => {
            existingList.innerHTML += article;
          });
        }
      });
    }
    function loadPage(page, append, filters) {
      const stateData = state();

      stateData.page = page.toString();
      const newQueryString = Object.entries(stateData)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');

      window.history.replaceState({}, '', `${window.location.pathname}?${newQueryString}`);

      const formData = queryStringToFormData(stateData, filters);
      let payload = formData;

      if (window[callbackName]) {
        payload = window[callbackName](formData);
      }

      fetch(url.toString(), {
        method: 'POST',
        body: payload,
      })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              const targetElement = document.querySelector(changedWrapper);

              if (targetElement) {
                let itemsText = '';

                if (Array.isArray(data.data)) {
                  data.data.forEach(item => {
                    itemsText += item;
                  });
                } else if (typeof data.data === 'string') {
                  itemsText = data.data;
                } else if (typeof data.data === 'object') {
                  itemsText = data.data;
                }

                if (data.meta.logic === 'date') {
                  const templateHeader = document.querySelector('.js--pagination_template_header');
                  const templateList = document.querySelector('.js--pagination_template_items');
                  if (append) {
                    renderArchive(itemsText, targetElement, templateHeader, templateList);
                    showMoreBtn.classList.remove('loading');
                  } else {
                    targetElement.innerHTML = '';
                    renderArchive(itemsText, targetElement, templateHeader, templateList);
                    activePrevPagesArray = [];
                    setTimeout(() => {
                      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                      const offsetPosition = elementPosition - 100;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    }, 300);

                    document.querySelectorAll('.js--page_item').forEach(function (item) {
                      item.classList.remove('active');
                    });
                  }
                } else {
                  if (append) {
                    targetElement.innerHTML += itemsText;
                    showMoreBtn.classList.remove('loading');
                  } else {
                    targetElement.innerHTML = itemsText;
                    activePrevPagesArray = [];
                    setTimeout(() => {
                      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                      const offsetPosition = elementPosition - 100;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    }, 300);

                    document.querySelectorAll('.js--page_item').forEach(function (item) {
                      item.classList.remove('active');
                    });
                  }
                }

                activePage = page;
                pagination.setAttribute('data-page', activePage);
                pagination.setAttribute('data-pages', data.meta.pages);
                pageMobile.innerHTML = activePage;
                pagesMobile.innerHTML = data.meta.pages;

                if (data.meta.pages === 1) {
                    pagination.style.display = 'none';
                } else {
                    pagination.style.display = 'block';
                }

                document.dispatchEvent(new Event('utekaPostsLoaded'));
                checkNextPage(data.meta.next_page)
                updatePaginationState();
                replacePaginationItems(data.pagination);
                addEventPageItems();

                if (append) {
                  const prevPage = parseInt(page) - 1;
                  activePrevPagesArray.push(prevPage);

                  document.querySelectorAll('.js--page_item').forEach(function (item) {
                    const itemPage = getItemPage(item);


                    if (activePrevPagesArray.includes(itemPage)) {
                      item.classList.add('active');
                    }
                  });
                }
              }

              if (totalWrapperElements) {
                  totalWrapperElements.forEach((element) => {
                      element.innerHTML = data.meta.total
                  })
              }

              const titleTemplate = document.querySelector('meta[name=title-template]')

              if (titleTemplate) {
                document.title = titleTemplate.content.replace('{page}', data.meta.current_page)
              }
            } else {
              notyf.error(data.message ?? 'no data.message found');
            }

          })
          .catch(error => {
            console.error('Ошибка загрузки страницы:', error);
          });
    }

    document.addEventListener('channelChange', () => {
      loadPage(1, false, dataFilters);
    });
    document.addEventListener('filterChange', () => {
      loadPage(1, false, dataFilters);
    });

    showMoreBtn.addEventListener('click', function (event) {
      showMoreBtn.classList.add('loading');
      event.preventDefault();

      if (activePage < getTotalPages()) {
        const nextPage = activePage + 1;
        loadPage(nextPage, true, dataFilters);
        updateQueryString(nextPage);
      }
    });

    updatePaginationState();

    addEventPageItems();

    pageFirstBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (!this.classList.contains('disabled')) {
        loadPage(1, false, dataFilters);
      }
    });

    pageLastBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (!this.classList.contains('disabled')) {
        loadPage(getTotalPages(), false, dataFilters);
      }
    });

    pagePrevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (!this.classList.contains('disabled') && activePage > 1) {
        loadPage(activePage - 1, false, dataFilters);
      }
    });

    pageNextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (!this.classList.contains('disabled') && activePage < getTotalPages()) {
        loadPage(activePage + 1, false, dataFilters);
      }
    });
  }
}

